export function defaultDropzoneOptions() {
  return {
    maxFilesize: 10, // default filesize in MB
    url: `${import.meta.env.VITE_APP_BACKEND_URL}/v1/files`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
    withCredentials: true,
  }
}